<div class="help-contact">
  <h1 class="help-contact__title text-primary-500 m-0 text-uppercase">Podemos Ayudarte</h1>
  <p class="help-contact__description text-center">
    Si necesitas más información, contáctanos. Estamos aquí para ofrecerte <br class="only-web" />respuestas rápidas y atención personalizada.
  </p>
  <div class="help-contact__numbers">
    <p class="help-contact__numbers__one text-gray-green-700">
      CDMX
      <a href="tel:+525513151498"
        ><span class="text-primary-500">(55) 1315 1498</span></a
      >
    </p>
    <p class="help-contact__numbers__divider">|</p>
    <p class="help-contact__numbers__two text-gray-green-700">
      GDL
      <a href="tel:+523347701170"
        ><span class="text-primary-500">(33) 4770 1170</span></a
      >
    </p>
  </div>
  <div class="help-contact__sell">
    <a href="mailto:ventas@proquifa.com.mx">
      ventas&#64;proquifa.com.mx
    </a>
  </div>
  <div class="help-contact__certifications">
    <img src="assets/imgs/osi.svg" alt="iso" />
    <img src="assets/imgs/oea.svg" alt="oea" />
  </div>
</div>
